import { Outlet, useNavigate, useLocation } from 'react-router-dom'
import { LogOut, User, Package, Users, Scan, Printer, TrendingUp, BarChart3, Menu, X, Bot } from 'lucide-react'
import { useAuthStore } from '../stores/authStore'
import { toast } from 'sonner'
import { useState } from 'react'

export default function Layout() {
    const { user, logout } = useAuthStore()
    const navigate = useNavigate()
    const location = useLocation()
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false)

    // Admin yetkisi kontrolü
    const isAdmin = user?.roles?.includes('admin') || user?.permissions?.includes('users:read')

    const handleLogout = () => {
        logout()
        toast.success('Başarıyla çıkış yapıldı')
        navigate('/login')
    }

    const toggleMobileMenu = () => {
        setIsMobileMenuOpen(!isMobileMenuOpen)
    }

    const handleNavigation = (path: string) => {
        navigate(path)
        setIsMobileMenuOpen(false)
    }

    return (
        <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-50">
            {/* Header */}
            <header className="sticky top-0 z-40 backdrop-blur-xl bg-white/80 border-b border-white/20 shadow-sm">
                <div className="w-full px-4 sm:px-6 lg:px-8">
                    <div className="flex justify-between items-center h-16">
                        {/* Logo */}
                        <div className="flex items-center">
                            <div className="h-9 w-9 rounded-xl bg-gradient-to-r from-blue-600 to-indigo-600 flex items-center justify-center mr-3">
                                <Package className="h-5 w-5 text-white" />
                            </div>
                            <h1 className="text-lg font-bold bg-gradient-to-r from-slate-900 via-blue-900 to-indigo-900 bg-clip-text text-transparent">
                                STOK TAKİP SİSTEMİ
                            </h1>
                        </div>

                        {/* Mobile Menu Button */}
                        <button
                            onClick={toggleMobileMenu}
                            className="sm:hidden p-2 rounded-lg text-slate-700 hover:bg-slate-100 transition-colors"
                        >
                            {isMobileMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
                        </button>

                        {/* Desktop Navigation */}
                        <nav className="hidden sm:flex space-x-2 bg-slate-100 rounded-xl p-1">
                            <button
                                onClick={() => handleNavigation('/products')}
                                className={`px-3 py-1.5 rounded-lg text-sm font-medium transition-colors ${location.pathname === '/products'
                                    ? 'bg-white shadow text-slate-900'
                                    : 'text-slate-700 hover:bg-white hover:shadow'
                                    }`}
                            >
                                Ürünler
                            </button>
                            <button
                                onClick={() => handleNavigation('/orders')}
                                className={`px-3 py-1.5 rounded-lg text-sm font-medium transition-colors ${location.pathname === '/orders'
                                    ? 'bg-white shadow text-slate-900'
                                    : 'text-slate-700 hover:bg-white hover:shadow'
                                    }`}
                            >
                                Siparişler
                            </button>
                            {isAdmin && (
                                <button
                                    onClick={() => handleNavigation('/statistics')}
                                    className={`px-3 py-1.5 rounded-lg text-sm font-medium transition-colors ${location.pathname === '/statistics'
                                        ? 'bg-white shadow text-slate-900'
                                        : 'text-slate-700 hover:bg-white hover:shadow'
                                        }`}
                                >
                                    İstatistikler
                                </button>
                            )}
                            {isAdmin && (
                                <button
                                    onClick={() => handleNavigation('/velocity')}
                                    className={`px-3 py-1.5 rounded-lg text-sm font-medium transition-colors ${location.pathname === '/velocity'
                                        ? 'bg-white shadow text-slate-900'
                                        : 'text-slate-700 hover:bg-white hover:shadow'
                                        }`}
                                >
                                    <div className="flex items-center space-x-1">
                                        <TrendingUp className="h-4 w-4" />
                                        <span>Velocity</span>
                                    </div>
                                </button>
                            )}
                            {isAdmin && (
                                <button
                                    onClick={() => handleNavigation('/stock-tracking')}
                                    className={`px-3 py-1.5 rounded-lg text-sm font-medium transition-colors ${location.pathname === '/stock-tracking'
                                        ? 'bg-white shadow text-slate-900'
                                        : 'text-slate-700 hover:bg-white hover:shadow'
                                        }`}
                                >
                                    <div className="flex items-center space-x-1">
                                        <BarChart3 className="h-4 w-4" />
                                        <span>Stok Takip</span>
                                    </div>
                                </button>
                            )}
                            <button
                                onClick={() => handleNavigation('/barcode-control')}
                                className={`px-3 py-1.5 rounded-lg text-sm font-medium transition-colors ${location.pathname === '/barcode-control'
                                    ? 'bg-white shadow text-slate-900'
                                    : 'text-slate-700 hover:bg-white hover:shadow'
                                    }`}
                            >
                                <div className="flex items-center space-x-1">
                                    <Scan className="h-4 w-4" />
                                    <span>Barkod Kontrol</span>
                                </div>
                            </button>
                            <button
                                onClick={() => handleNavigation('/label-print')}
                                className={`px-3 py-1.5 rounded-lg text-sm font-medium transition-colors ${location.pathname === '/label-print'
                                    ? 'bg-white shadow text-slate-900'
                                    : 'text-slate-700 hover:bg-white hover:shadow'
                                    }`}
                            >
                                <div className="flex items-center space-x-1">
                                    <Printer className="h-4 w-4" />
                                    <span>Etiket Yazdır</span>
                                </div>
                            </button>
                            {isAdmin && (
                                <button
                                    onClick={() => handleNavigation('/chatbot')}
                                    className={`px-3 py-1.5 rounded-lg text-sm font-medium transition-colors ${location.pathname === '/chatbot'
                                        ? 'bg-white shadow text-slate-900'
                                        : 'text-slate-700 hover:bg-white hover:shadow'
                                        }`}
                                >
                                    <div className="flex items-center space-x-1">
                                        <Bot className="h-4 w-4" />
                                        <span>AI Asistan</span>
                                    </div>
                                </button>
                            )}
                            {isAdmin && (
                                <button
                                    onClick={() => handleNavigation('/users')}
                                    className={`px-3 py-1.5 rounded-lg text-sm font-medium transition-colors ${location.pathname === '/users'
                                        ? 'bg-white shadow text-slate-900'
                                        : 'text-slate-700 hover:bg-white hover:shadow'
                                        }`}
                                >
                                    <div className="flex items-center space-x-1">
                                        <Users className="h-4 w-4" />
                                        <span>Kullanıcılar</span>
                                    </div>
                                </button>
                            )}
                        </nav>

                        {/* User menu */}
                        <div className="flex items-center space-x-3">
                            <div className="hidden sm:flex items-center space-x-2 bg-white/70 px-3 py-1.5 rounded-lg">
                                <User className="h-4 w-4 text-slate-500" />
                                <span className="text-sm text-slate-700">
                                    {user?.firstName} {user?.lastName}
                                </span>
                            </div>

                            <button
                                onClick={handleLogout}
                                className="flex items-center space-x-2 text-slate-700 hover:text-red-600 px-3 py-1.5 rounded-lg text-sm font-medium transition-colors bg-white/70 hover:bg-white"
                            >
                                <LogOut className="h-4 w-4" />
                                <span>Çıkış</span>
                            </button>
                        </div>
                    </div>
                </div>
            </header>

            {/* Mobile Menu */}
            {isMobileMenuOpen && (
                <div className="sm:hidden fixed top-16 left-0 right-0 bottom-0 bg-white/95 backdrop-blur-xl shadow-lg z-50 overflow-y-auto">
                    <div className="px-4 py-4 space-y-2">
                        {/* Navigation Links */}
                        <button
                            onClick={() => handleNavigation('/products')}
                            className={`w-full flex items-center px-4 py-3 rounded-lg text-sm font-medium transition-colors ${location.pathname === '/products'
                                ? 'bg-blue-100 text-blue-900'
                                : 'text-slate-700 hover:bg-slate-100'
                                }`}
                        >
                            <Package className="h-5 w-5 mr-3" />
                            Ürünler
                        </button>

                        <button
                            onClick={() => handleNavigation('/orders')}
                            className={`w-full flex items-center px-4 py-3 rounded-lg text-sm font-medium transition-colors ${location.pathname === '/orders'
                                ? 'bg-blue-100 text-blue-900'
                                : 'text-slate-700 hover:bg-slate-100'
                                }`}
                        >
                            <Package className="h-5 w-5 mr-3" />
                            Siparişler
                        </button>

                        {isAdmin && (
                            <button
                                onClick={() => handleNavigation('/statistics')}
                                className={`w-full flex items-center px-4 py-3 rounded-lg text-sm font-medium transition-colors ${location.pathname === '/statistics'
                                    ? 'bg-blue-100 text-blue-900'
                                    : 'text-slate-700 hover:bg-slate-100'
                                    }`}
                            >
                                <BarChart3 className="h-5 w-5 mr-3" />
                                İstatistikler
                            </button>
                        )}

                        {isAdmin && (
                            <button
                                onClick={() => handleNavigation('/velocity')}
                                className={`w-full flex items-center px-4 py-3 rounded-lg text-sm font-medium transition-colors ${location.pathname === '/velocity'
                                    ? 'bg-blue-100 text-blue-900'
                                    : 'text-slate-700 hover:bg-slate-100'
                                    }`}
                            >
                                <TrendingUp className="h-5 w-5 mr-3" />
                                Velocity
                            </button>
                        )}

                        {isAdmin && (
                            <button
                                onClick={() => handleNavigation('/stock-tracking')}
                                className={`w-full flex items-center px-4 py-3 rounded-lg text-sm font-medium transition-colors ${location.pathname === '/stock-tracking'
                                    ? 'bg-blue-100 text-blue-900'
                                    : 'text-slate-700 hover:bg-slate-100'
                                    }`}
                            >
                                <BarChart3 className="h-5 w-5 mr-3" />
                                Stok Takip
                            </button>
                        )}

                        <button
                            onClick={() => handleNavigation('/barcode-control')}
                            className={`w-full flex items-center px-4 py-3 rounded-lg text-sm font-medium transition-colors ${location.pathname === '/barcode-control'
                                ? 'bg-blue-100 text-blue-900'
                                : 'text-slate-700 hover:bg-slate-100'
                                }`}
                        >
                            <Scan className="h-5 w-5 mr-3" />
                            Barkod Kontrol
                        </button>

                        <button
                            onClick={() => handleNavigation('/label-print')}
                            className={`w-full flex items-center px-4 py-3 rounded-lg text-sm font-medium transition-colors ${location.pathname === '/label-print'
                                ? 'bg-blue-100 text-blue-900'
                                : 'text-slate-700 hover:bg-slate-100'
                                }`}
                        >
                            <Printer className="h-5 w-5 mr-3" />
                            Etiket Yazdır
                        </button>

                        {isAdmin && (
                            <button
                                onClick={() => handleNavigation('/chatbot')}
                                className={`w-full flex items-center px-4 py-3 rounded-lg text-sm font-medium transition-colors ${location.pathname === '/chatbot'
                                    ? 'bg-blue-100 text-blue-900'
                                    : 'text-slate-700 hover:bg-slate-100'
                                    }`}
                            >
                                <Bot className="h-5 w-5 mr-3" />
                                AI Asistan
                            </button>
                        )}

                        {isAdmin && (
                            <button
                                onClick={() => handleNavigation('/users')}
                                className={`w-full flex items-center px-4 py-3 rounded-lg text-sm font-medium transition-colors ${location.pathname === '/users'
                                    ? 'bg-blue-100 text-blue-900'
                                    : 'text-slate-700 hover:bg-slate-100'
                                    }`}
                            >
                                <Users className="h-5 w-5 mr-3" />
                                Kullanıcılar
                            </button>
                        )}

                        {/* User Info and Logout */}
                        <div className="border-t border-slate-200 pt-4 mt-4">
                            <div className="flex items-center px-4 py-2 mb-3">
                                <User className="h-5 w-5 text-slate-500 mr-3" />
                                <span className="text-sm text-slate-700">
                                    {user?.firstName} {user?.lastName}
                                </span>
                            </div>

                            <button
                                onClick={handleLogout}
                                className="w-full flex items-center px-4 py-3 rounded-lg text-sm font-medium text-red-600 hover:bg-red-50 transition-colors"
                            >
                                <LogOut className="h-5 w-5 mr-3" />
                                Çıkış
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* Main content */}
            <main className="w-full py-6 sm:px-6 lg:px-8">
                <Outlet />
            </main>
        </div>
    )
}
